
// src/components/Metrics.js
import React from 'react';
import { formatNumber } from '../utils/format';
import definitions from '../definitionPlaceholders.json';
import Tooltip from './Tooltip';

const Metrics = ({ selectedCompany, stockSymbol, metricsData }) => {
  const defaultMetrics = {
    'Total Revenue': 'N/A',
    'Gross Profit': 'N/A',
    'Gross Profit Ratio': 'N/A',
    'EBITDA': 'N/A',
    'EBITDA Ratio': 'N/A',
    'Income Before Tax': 'N/A',
    'Income Before Tax Ratio': 'N/A',
    'Net Income': 'N/A',
    'Net Income Ratio': 'N/A',
    'Operating Income': 'N/A',
    'Operating Income Ratio': 'N/A',
    'Earnings Per Share': 'N/A',
  };

  const definitionKeyMap = {
    'Net Income': 'netIncome',
    'Total Revenue': 'totalRevenue',
    'Gross Profit': 'grossProfit',
    'Gross Profit Ratio': 'grossProfitRatio',
    'EBITDA': 'ebitda',
    'EBITDA Ratio': 'ebitdaRatio',
    'Income Before Tax': 'incomeBeforeTax',
    'Income Before Tax Ratio': 'incomeBeforeTaxRatio',
    'Net Income Ratio': 'netIncomeRatio',
    'Operating Income': 'operatingIncome',
    'Operating Income Ratio': 'operatingIncomeRatio',
    'Earnings Per Share': 'earningsPerShare',
  };

  const displayMetrics = { ...defaultMetrics, ...(metricsData || {}) };

  return (
    <div className="w-full my-4">
      <div className="card p-5 min-h-[625px]">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-1 h-6 bg-income rounded-full" />
          <h2 className="section-heading">
            Income Statement{selectedCompany ? ` | ${selectedCompany}` : ''}{stockSymbol ? ` | ${stockSymbol}` : ''}
          </h2>
        </div>

        <div className="grid grid-cols-2 gap-3 w-full min-w-0">
          {Object.keys(displayMetrics).map((key, index) => {
            const defKey = definitionKeyMap[key];
            const defText = defKey ? definitions[defKey] : null;

            return (
              <div
                key={index}
                className="relative bg-income-light border border-green-200 p-4 rounded-lg min-h-[96px] card-hover overflow-x-hidden overflow-y-visible"
              >
                {defText && (
                  <Tooltip content={defText}>
                    <span
                      className="absolute top-2 left-2 text-xs text-gray-500 cursor-help"
                      tabIndex={0}
                      aria-label={`Definition for ${key}`}
                    >
                      ℹ️
                    </span>
                  </Tooltip>
                )}

                <div className="absolute bottom-2 left-2 right-2 text-xs sm:text-sm font-medium text-gray-600 break-words">
                  {key}
                </div>

                <div className="absolute top-5 right-3 left-8 text-sm sm:text-lg font-semibold text-income-dark text-right break-words">
                  {formatNumber(key, displayMetrics[key], defKey)}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Metrics;

